import { AxiosHttpService } from "services/AxiosHttpService";
import { CategoryReportRepository } from "repository/custom_reports/CategoryReportRepository";
import { ReportRepository } from "repository/custom_reports/ReportRepository";
import { createApiClient } from "utils/AxiosClient";
import { ICacheService } from './ICacheService';
import { CacheService } from 'services/CacheService';

export class ReportService {
    private cacheService: ICacheService;

    private httpService: IHttpService

    public category: ICategoryReportRepository
    public report: IReportRepository

    constructor(url?: string) {
            this.cacheService = new CacheService('tk-cache-db');
        const baseURL = url ? url : `${process.env.REACT_APP_TK_GW_DOMAIN}/v1/custom_reports`;
        const apiClient = createApiClient(baseURL)
        this.httpService = new AxiosHttpService(apiClient, this.cacheService);
        this.category = new CategoryReportRepository(this.httpService);
        this.report = new ReportRepository(this.httpService);
    }

}